export const title = {
  title() {
    const title = !this.taxonLoaded
      ? this.$i18n.t('browse')
      : this.name
    document.title = title
    return title
  },
}